import { render } from "./AllLeaves.vue?vue&type=template&id=5e1ede9c&scoped=true"
import script from "./AllLeaves.vue?vue&type=script&lang=js"
export * from "./AllLeaves.vue?vue&type=script&lang=js"

import "./AllLeaves.vue?vue&type=style&index=0&id=5e1ede9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1ede9c"]])

export default __exports__